/* global newrelic */
import { PARAMETROS } from '@src/init-globals'
import con from '@services/connection'
import { user, emails } from '@constants/URL'
import store from '@state/store'
import { possivelJSON } from '@utils/Format'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'
import { apiGlobalDisclaimer } from '@modules/global/api/apiGlobalDisclaimer'
import { init as initGtag } from '@plugins/gtag'
import { trackLoginMethodOnce } from '@utils/loginTracking'

let timeOutReleaseNotes = null

let hasShowModalUpdates = false

const getCurrentUser = async (after) => {
  console.log('Coletando usuario atual')
  const data = {
    nome: 'Assessor Principal',
    id_interno: 18,
    escritorio: JSON.stringify({
      nome: 'AAWZ',
      id_interno: 1,
      logo_name: 'logo-aawz.png',
    }),
    tipo_usuario: 'GESTOR', // GESTOR, ASSESSOR, PLANEJADOR, CLIENTE
  }
  console.log(data)

  const r = await con.get(user.profile)
  store.dispatch('user/setLoadingUser', true)

  // const r = await con.post(dev.espelho, data)
  // if (r.status === 200) {
  if (typeof r === 'string' && r.indexOf('<!DOCTYPE html>') !== -1) {
    console.log('Sem login')
    store.dispatch('user/setCurrentUser', { loading: true })
  } else {
    store.dispatch('user/setCurrentUser', possivelJSON(r))

    apiGlobalDisclaimer.carregar()

    // Registra os handlers de trigger (CRM drag-to-Won → suggester modal).
    // Idempotente — chamadas subsequentes (re-login, refresh do user) sao no-op.
    // Dynamic require: avoids pre-loading triggerRegistry at module evaluation time
    // (parameters.js is imported by router which is imported by test setup, so a
    // static import would resolve apiTarefas before jest.mock applies).
    require('@modules/tarefas/services/triggerRegistry').boot()
  }

  managePermissions()

  // if (
  //   ['108', 108, '83', 83, '29', 29, '88', 88, '106', 106].includes(
  //     possivelJSON(r).escritorio.id_interno
  //   )
  // ) {
  //   store.dispatch('parameters/updateShowModule', {
  //     module: 'workspace',
  //     value: true,
  //   })
  //   store.dispatch('parameters/updateShowModule', {
  //     module: 'portfolio_review',
  //     value: true,
  //   })
  //   store.dispatch('parameters/updateShowModule', {
  //     module: 'settings',
  //     value: true,
  //   })
  // }

  // store.dispatch('simulador/loadStorage')

  store.dispatch('parameters/loadConfigLocal')

  if (store.getters['user/currentUser'].IS_CLIENTE) {
    // Verificar se precisa consentir com o crawler diário de alguma conta
    GlobalBus.$emit(MODAL.CONSENTIR_CRAWLER_DIARIO)
  }

  window.SHOW_WORKSPACE = window.WHITELABEL

  // }

  // https://app.clickup.com/t/1z4xb55
  // if (r && r.must_register_receiver_account) {
  //   GlobalBus.$emit(MODAL.ADD_BANK_ACCOUNT, {
  //     message: r.warning_message,
  //     migracao: true,
  //   })
  // }

  // TODO: Verificar qnd é necessário atualizar o cartão
  // GlobalBus.$emit(MODAL.CHANGE_CARD, {
  //   message:
  //     'Precisamos atualizar o seu cartão de crédito. Por favor, preencha os dados abaixo:',
  // })

  // Apresentacao do modal com notas de atualizacao
  const config_local = store.getters['parameters/config_local']
  const currentUser = store.getters['user/currentUser']
  setNewRelicVars(currentUser)
  setHJUser(currentUser)
  if (config_local.showModalUpdates && !hasShowModalUpdates) {
    clearTimeout(timeOutReleaseNotes)
    hasShowModalUpdates = true
    timeOutReleaseNotes = setTimeout(() => {
      if (currentUser.IS_CLIENTE) {
        // GlobalBus.$emit(MODAL.RELEASE_NOTES_CLIENTE)
      } else {
        // GlobalBus.$emit(MODAL.RELEASE_NOTES)
      }

      store.dispatch('parameters/saveConfigLocal', {
        showModalUpdates: false,
      })
    }, 2000)
  }

  // Enquanto não temos um novo modal de novidades, vamos definir todo mundo
  // para aparecer novamente. Para os casos onde o usuário marcou em
  // "não mostrar novamente".
  store.dispatch('parameters/saveConfigLocal', {
    showModalUpdates: true,
  })

  if (!currentUser.IS_INTERNAL) {
    const escritorio = currentUser.escritorio || {}
    initGtag({
      id_interno: currentUser.id_interno,
      id_escritorio: escritorio.id_interno,
    })
    // Dispara o evento de login (login_<metodo>) UMA vez por sessão, apenas
    // para usuário não interno. Idempotente — chamadas subsequentes são no-op.
    trackLoginMethodOnce()
  }

  if (after) {
    after()
  }

  setTimeout(() => {
    store.dispatch('user/setLoadingUser', false)
  }, 3000)
}

const setNewRelicVars = (user) => {
  if (typeof newrelic === 'object') {
    newrelic.setCustomAttribute('user_id', user.id_interno, true)
    newrelic.setCustomAttribute('user_internal', user.IS_INTERNAL ? 1 : 0, true)
    newrelic.setCustomAttribute('user_type', user.tipo_usuario, true)
    newrelic.setCustomAttribute('user_leader', user.leader ? 1 : 0, true)
    newrelic.setCustomAttribute('user_role', user.role, true)
    if (user.escritorio) {
      newrelic.setCustomAttribute(
        'user_office_id',
        user.escritorio.id_interno,
        true
      )
    }
    console.log('[NEWRELIC] Variaveis do newrelic definidas')
  } else {
    console.log('[NEWRELIC] newrelic nao configurado')
  }
}

const setHJUser = (user) => {
  if (typeof window.hj === 'function') {
    const escritorio = user.escritorio || {}
    window.hj('identify', user.id_interno, {
      office: escritorio.nome || escritorio.id_interno || '',
      user_internal: user.IS_INTERNAL ? 1 : 0,
      user_type: user.tipo_usuario,
      user_leader: user.leader ? 1 : 0,
      user_role: user.role,
    })

    console.log('[HJ] Variaveis definidas')
  } else {
    console.log('[HJ] Hotjar nao disponivel')
  }
}

const getEmails = async () => {
  return new Promise(async (resolve, reject) => {
    const data = {
      emails: JSON.stringify([
        {
          email: 'aawz@aawz.com.br',
          validated: true,
        },
        {
          email: 'primeiro@wa.com.br',
          validated: false,
        },
        {
          email: 'segundo@asd.com.br',
          validated: true,
        },
      ]),
    }
    const r = await con.get(emails.list, data)
    store.dispatch('user/setEmails', possivelJSON(r.value))
    resolve(true)
  })
}

const managePermissions = () => {
  // TODO: Se colocar ao iniciar o sistema não fica mais adequado?
  const feature_access = possivelJSON(PARAMETROS.features_access || {})

  const MAP_SUB_PERMISSIONS = {
    Estratégia: [
      'biGeral',
      'biPartnership',
      'biCarreira',
      'biExpansao',
      'biFinanceiro',
      'biIndividual',
      'biSettings',
      'biPlanilhas',
      'biProfissionais',
      'biMix',
    ],
  }

  Object.entries(feature_access).forEach((access) => {
    store.dispatch('parameters/updateShowModule', {
      module: access[0],
      value: access[1],
    })
    if (MAP_SUB_PERMISSIONS[access[0]]) {
      for (let sub of MAP_SUB_PERMISSIONS[access[0]]) {
        store.dispatch('parameters/updateShowModule', {
          module: sub,
          value: access[1],
        })
      }
    }
  })
}

// getCurrentUser()

export { setHJUser }

export default {
  getCurrentUser,
  getEmails,
}
